import { render } from "./SysActivity.vue?vue&type=template&id=c866e79c"
import script from "./SysActivity.vue?vue&type=script&lang=js"
export * from "./SysActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__